import { FC, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import styles from './truncatedText.module.scss'

interface TruncatedTextProps {
  // Carries the ellipsis (overflow hidden, nowrap, text-overflow).
  className?: string
  text: string
}

// One line cut with an ellipsis; when it is cut, hovering shows the whole text
// in the app's dark tooltip instead of the browser's native title box.
export const TruncatedText: FC<TruncatedTextProps> = ({ className, text }) => {
  const ref = useRef<HTMLSpanElement>(null)
  const [tip, setTip] = useState<{ x: number; y: number } | null>(null)

  const show = () => {
    const el = ref.current
    if (el && el.scrollWidth > el.clientWidth) {
      const rect = el.getBoundingClientRect()
      setTip({ x: rect.left + rect.width / 2, y: rect.top })
    }
  }

  return (
    <span
      className={`${styles.text} ${className ?? ''}`}
      onMouseEnter={show}
      onMouseLeave={() => setTip(null)}
      ref={ref}
    >
      {text}
      {tip &&
        createPortal(
          <span className={styles.tooltip} style={{ left: tip.x, top: tip.y }}>
            {text}
          </span>,
          document.body
        )}
    </span>
  )
}
